const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (process.env.NODE_ENV === "development") {
    return "https://api.jusstools.com";
  }

  return "https://api.jusstools.com";
};

const apiurl = getApiUrl();

export default apiurl;
